<h2>Modules de formation</h2>
<div class="documentation-container">
    <div class="documentation-card">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 88 88">
            <rect x="8"  y="20" width="28" height="28" rx="4" fill="#1C6ED5"/>
            <rect x="32" y="12" width="28" height="28" rx="4" fill="#4FA3E3"/>
            <rect x="52" y="32" width="28" height="28" rx="4" fill="#00D1C2"/>
            <rect x="24" y="44" width="28" height="28" rx="4" fill="#7E5AFF"/>
        </svg>


        <h3>Présentation</h3>
        <p>Module 1: Intégration de contenu </p>
        <a (click)="launchService('content-presentation')">Lire</a>
    </div>

    <div class="documentation-card">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 88 88">
            <path d="M44 18L26 36h12v20h12V36h12L44 18z" fill="#1C6ED5"/>
            <rect x="20" y="58" width="48" height="10" rx="4" fill="#1C6ED5"/>
        </svg>

        <h3>Chargement de contenus</h3>
        <p>Module 2: Comment charger les ressources dans la platefrorme de traitement?</p>
        <a (click)="launchService('content-upload')">Lire</a>
    </div>

    <div class="documentation-card">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 88 88">
            <rect x="18" y="14" width="52" height="18" rx="6" fill="#1C6ED5"/>
            <rect x="12" y="36" width="52" height="18" rx="6" fill="#4FA3E3"/>
            <rect x="26" y="58" width="52" height="18" rx="6" fill="#00D1C2"/>
        </svg>

        <h3>Découpage et Classification</h3>
        <p>Module 3: Comment découper, rassembler correctement les ressources</p>
        <a (click)="launchService('content-splitting')">Lire</a>
    </div>

    <div class="documentation-card">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 88 88">
            <rect x="18" y="16" width="52" height="56" rx="6" fill="#1C6ED5"/>
            <path d="M58 22l10 10-24 24-10-10 24-24z" fill="#00D1C2"/>
            <rect x="24" y="28" width="32" height="6" rx="3" fill="#ffffff"/>
        </svg>

        <h3>Edition de contenus</h3>
        <p>Module 4: Les principes à adopter lors de l'édition de contenu</p>
        <a (click)="launchService('content-edition')">Lire</a>
    </div>
    <div class="documentation-card">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 88 88">
            <rect x="18" y="16" width="52" height="56" rx="6" fill="#1C6ED5"/>
            <path d="M58 22l10 10-24 24-10-10 24-24z" fill="#00D1C2"/>
            <rect x="24" y="28" width="32" height="6" rx="3" fill="#ffffff"/>
        </svg>

        <h3>Edition de contenus</h3>
        <p>Chimie: Edition de formule Chimique</p>
        <a (click)="launchService('chemistry-formular')">Lire</a>
    </div>

    <div class="documentation-card">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 88 88">
            <rect x="20" y="14" width="48" height="60" rx="6" fill="#1C6ED5"/>
            <rect x="28" y="26" width="32" height="6" rx="3" fill="#ffffff"/>
            <rect x="28" y="38" width="32" height="6" rx="3" fill="#ffffff"/>
            <rect x="28" y="50" width="32" height="6" rx="3" fill="#ffffff"/>
        </svg>

        <h3>Documentation</h3>
        <p>Cours complet sur l'intégration de contenus</p>
        <a (click)="launchService('content-documentation')">Lire</a>
    </div>

    <div class="documentation-card">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 88 88">
            <rect x="20" y="14" width="48" height="60" rx="6" fill="#1C6ED5"/>
            <rect x="28" y="26" width="32" height="6" rx="3" fill="#ffffff"/>
            <rect x="28" y="38" width="32" height="6" rx="3" fill="#ffffff"/>
            <rect x="28" y="50" width="32" height="6" rx="3" fill="#ffffff"/>
        </svg>

        <h3>Templates</h3>
        <p>Les templates pour la saisie</p>
        <a (click)="launchService('content-templates')">Ouvrir</a>
    </div>
</div>
